const stickify = el => {

  let elTop = el.offsetTop,
    navTop = document.querySelector('.header-container');

  let stickyElement = () => {
    if(navTop) {
      if (window.scrollY >= (elTop - el.offsetHeight)) {
        el.classList.add('stuck');
        navTop.classList.add('x2');
        setTimeout(() => {
          el.classList.add('show');
        }, 100);
      } else {
        el.classList.remove('stuck');
        el.classList.remove('show');
        navTop.classList.remove('x2');
      }
    }
  }

  window.addEventListener('scroll', stickyElement);
  window.addEventListener('resize', stickyElement);
}

export default stickify;
